import { Injectable, signal } from '@angular/core';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly visible   = signal(false);
  readonly options   = signal<ConfirmOptions>({ message: '' });

  private resolveFn: ((v: boolean) => void) | null = null;

  confirm(opts: ConfirmOptions): Promise<boolean> {
    this.options.set(opts);
    this.visible.set(true);
    return new Promise(resolve => { this.resolveFn = resolve; });
  }

  resolve(value: boolean): void {
    this.visible.set(false);
    this.resolveFn?.(value);
    this.resolveFn = null;
  }
}
